exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-logo[data-v-1919babe]{width:-webkit-min-content;width:-moz-min-content;width:min-content}", ""]);

// exports
